import { Create, useForm } from "@refinedev/antd";
import { HttpError } from '@refinedev/core';
import { Form, Input } from "antd";
import { ImageUpload } from "../../../components/ImageUpload";

export function OfferCreate() {
  const { formProps, saveButtonProps, formLoading } = useForm<any, HttpError, any>({
    resource: "offer",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
  });

  return (
    <Create
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="offer"
      title="Create Offer"
    >
      <Form 
        {...formProps} 
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name={["name"]}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name={["description"]}
          rules={[{ required: true }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Icon"
          name="iconID"
        >
          <ImageUpload />
        </Form.Item>
      </Form>
    </Create>
  );
}

